import { CommonModule } from '@angular/common';
import { Component, inject, Input, NgModule, OnInit } from '@angular/core';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { CrmTranslatePipe } from 'common-module/translate';
import { NzButtonType } from 'ng-zorro-antd/button/button.component';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-confirm-action-modal',
  templateUrl: './confirm-action-modal.component.html',
  styleUrls: ['./confirm-action-modal.component.less']
})
export class ConfirmActionModalComponent implements OnInit {
  @Input() public title?: string;
  @Input() public body?: string;

  @Input() public confirmText?: string;
  @Input() public cancelText?: string;

  @Input() public confirmButtonStyle?: any;
  @Input() public cancelButtonStyle?: any;

  @Input() public confirmBtnType?: NzButtonType = 'primary';

  private modalData = inject(NZ_MODAL_DATA);

  public ngOnInit() {
    const {
      title,
      body,
      confirmText,
      confirmBtnType,
      cancelText,
      handleConfirmClick,
      handleCancelClick,
      confirmButtonStyle
    } = this.modalData;

    this.title = title;
    this.body = body;
    this.confirmText = confirmText;
    this.confirmBtnType = confirmBtnType;
    this.cancelText = cancelText;
    this.confirmButtonStyle = confirmButtonStyle;
    this.handleConfirmClick = handleConfirmClick;
    this.handleCancelClick = handleCancelClick;
  }

  public handleConfirmClick?: () => void = () => {};
  public handleCancelClick?: () => void = () => {};
}

@NgModule({
  declarations: [ConfirmActionModalComponent],
  exports: [ConfirmActionModalComponent],
  imports: [CommonModule, ButtonComponent, CrmTranslatePipe],
  entryComponents: [ConfirmActionModalComponent]
})
export class ConfirmActionModalModule {}
